'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DefaultLayout = undefined;

var _DefaultLayout2 = require('./DefaultLayout');

var _DefaultLayout3 = _interopRequireDefault(_DefaultLayout2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.DefaultLayout = _DefaultLayout3.default;


//////////////////
// WEBPACK FOOTER
// ./src/pages/layouts/index.js
// module id = 2936
// module chunks = 0